import { CAMPWindow } from "../../CAMPWindow";

declare const window: CAMPWindow;

export const trackView = (testingVariant: string | null | undefined, testingName: string | null | undefined): void => {
    if (testingVariant && testingName) {
        window.dataLayer?.push({
            event: "testing.userAssigned",
            testing_domain: "entd",
            testing_name: testingName,
            testing_variant: testingVariant,
        });
    }
};
